import { fetchFromVolatileServer } from "../utils/fetchFromVolatileServer";
import { getUrl } from "../utils/url";

export const getChildPages = async ({
  id,
  locale,
  defaultLocale,
}: {
  id: number;
  locale: string;
  defaultLocale: string;
}) => {
  const pagesRes = await fetchFromVolatileServer(
    `${getUrl(locale, defaultLocale)}/pages?_fields=id&parent=${id}`,
  );
  return await pagesRes.json();
};
/* jscpd:ignore-start */
export const hasChildPages = async ({
  id,
  locale,
  defaultLocale,
}: {
  id: number;
  locale: string;
  defaultLocale: string;
}) => {
  const pagesRes = await getChildPages({ id, locale, defaultLocale });
  return pagesRes.length > 0;
};
/* jscpd:ignore-end */
